<footer class="nlc-footer">
  <div class="nlc-container">
    <div class="nlc-footer-content">
      <!-- Footer Links -->
      <nav class="nlc-footer-nav">
        <a routerLink="/faq" class="nlc-footer-link">FAQ</a>
        <span class="nlc-footer-separator">·</span>
        <a routerLink="/feedback" class="nlc-footer-link">Feedback</a>
        <span class="nlc-footer-separator">·</span>
        <a routerLink="/impressum" class="nlc-footer-link">Impressum</a>
        <ng-container *ngIf="!(authService.isAuthenticated$ | async)">
          <span class="nlc-footer-separator">·</span>
          <a (click)="navigateToEmployeeLogin()" class="nlc-footer-link nlc-footer-link-clickable">Mitarbeiteranmeldung</a>
        </ng-container>
      </nav>

      <!-- Copyright -->
      <div class="nlc-footer-copyright">
        <p class="nlc-caption">&copy; 2025 NicLen GmbH. Alle Rechte vorbehalten.</p>
      </div>
    </div>
  </div>
</footer>
